import { AddressesApiRemoteService } from '../../Services/api/addresses/addresses-service'
import { IAddressEntity, IAddressSearchResponse } from '../../Services/api/addresses/addresses.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class UpdateAddressesUseCase
implements IFormUsecase<IAddressEntity, void> {
  constructor (private readonly AddressesApi: AddressesApiRemoteService) {}
    

  public async handle (
    data: IAddressEntity
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.AddressesApi.update(data)

      if (response.isFailure) {
        return response
      }
    
   
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
